/**
 * Possible icon positions.
 */
export const ICON_POSITIONS = {
    START: 'start',
    END: 'end'
} as const;
